import React from 'react';
import './Header.css';

export interface HeaderProps {
  title?: string;
}

export const Header: React.FC<HeaderProps> = ({
  title = 'Mallard Notes',
}) => {
  return (
    <header className="header">
      <div className="header__content">
        <img src="/logo2.png" alt="Mallard Logo" className="header__logo" />
        <h1 className="header__title">{title}</h1>
      </div>
    </header>
  );
}; 